import appConstants from "../../../../appConstants";
import {
  formatESTDateTime,
  formatZeroValue,
  formatCSTTimeStringToEST,
} from "../../../dataGrid/gridUtilities";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration(config) {
    return GridConfig.getDefaultConfiguration();
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.IBPlanningSummary,
      keyColumn: "terminalCode",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Terminal",
          field: "terminalCode",
          minWidth: appConstants.columnWidth.REPORTS_TERMINALCODE,
          maxWidth: appConstants.columnWidth.REPORTS_TERMINALCODE,
          cellClass: "gridCell-centerAlign",
          cellClassRules: {
            "gridCellReport-published": "data.publishCount",
            "gridCellReport-notPublished": "!data.publishCount",
            "gridCellReport-dataNotReceived": "!data.firstPush",
          },
        },
        {
          headerName: "Name",
          field: "terminalName",
          tooltipField: "terminalName",
          minWidth: appConstants.columnWidth.REPORTS_TERMINALNAME,
        },
        {
          headerName: "AS400 Init Time",
          field: "initTime",
          valueGetter: (params) =>
            formatCSTTimeStringToEST({ value: params.data.initTime }),
          minWidth: appConstants.columnWidth.REPORTS_FIRSTPUSH,
        },
        {
          headerName: "First Push",
          field: "firstPush",
          minWidth: appConstants.columnWidth.REPORTS_FIRSTPUSH,
          valueGetter: (params) =>
            formatESTDateTime({ value: params.data.firstPush }),
        },
        {
          headerName: "First Publish",
          field: "firstPublish",
          minWidth: appConstants.columnWidth.REPORTS_FIRSTPUBLISH,
          valueGetter: (params) =>
            formatESTDateTime({ value: params.data.firstPublish }),
        },
        {
          headerName: "Latest Publish",
          field: "lastPublish",
          minWidth: appConstants.columnWidth.REPORTS_LASTPUBLISH,
          valueGetter: (params) =>
            formatESTDateTime({ value: params.data.lastPublish }),
        },
        {
          headerName: "Publish#",
          field: "publishCount",
          valueFormatter: formatZeroValue,
          minWidth: appConstants.columnWidth.REPORTS_PUBLISHCOUNT,
        },
        {
          headerName: "Published Pros",
          field: "totalPublishedPro#",
          minWidth: appConstants.columnWidth.REPORTS_FIRSTPUSH,
        },
        {
          headerName: "Total Pros",
          field: "totalPro#",
          minWidth: appConstants.columnWidth.REPORTS_PROCOUNT,
        },
        {
          headerName: "Routes#",
          field: "route#",
          minWidth: appConstants.columnWidth.REPORTS_ROUTECOUNT,
        },
        {
          headerName: "Region",
          field: "regionName",
          minWidth: appConstants.columnWidth.REPORTS_REGION,
        },
        {
          headerName: "Division",
          field: "divisionName",
          minWidth: appConstants.columnWidth.REPORTS_DIVISION,
        },
      ],
    };
  }
}
